const toJson = (value) => JSON.stringify(value, null, 2);
export {
  toJson
};
//# sourceMappingURL=to-json.js.map
